import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=25ea6f98&"
import script from "./MobileMenu.vue?vue&type=script&lang=js&"
export * from "./MobileMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25ea6f98')) {
      api.createRecord('25ea6f98', component.options)
    } else {
      api.reload('25ea6f98', component.options)
    }
    module.hot.accept("./MobileMenu.vue?vue&type=template&id=25ea6f98&", function () {
      api.rerender('25ea6f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/dashboard/MobileMenu.vue"
export default component.exports